import ReactGA from "react-ga";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import Demo from "./demo";

import PublicSample from "containers/Sample/public";
import CCHCSSignUp from "containers/SignUp/CCHCSSignUp";
import KitReceiptPage from "pages/admin/KitReceipt/KitReceipt";
import Auth from "./containers/Auth";
import SamplingLocationPublic from "./containers/SamplingLocation";
import CDCSignUp from "./containers/SignUp/CDCSignUp";
import NIDASignUp from "./containers/SignUp/NIDASignUp";
import NetworkCustomerOptIn from "./containers/SignUp/NetworkCustomerOptIn";
import NetworkSignUp from "./containers/SignUp/NetworkSignUp";
import UserForm from "./containers/UserForm/UserForm";
import NotFound from "./pages/NotFound/NotFound";
import AccountDetails from "./pages/admin/Accounts/AccountDetails/AccountDetails";
import Accounts from "./pages/admin/Accounts/Accounts";
import CreateProtocolPage from "./pages/admin/CreateProtocol/CreateProtocol";
import Invoicing from "./pages/admin/Invoicing/Invoicing";
import KitIssues from "./pages/admin/KitIssues/KitIssues";
import KitLookupPage from "./pages/admin/KitLookup/KitLookup";
import KitOperationalDashboard from "./pages/admin/KitOperationalDashboard";
import KitSelectionStatuses from "./pages/admin/KitSelectionStatuses/KitSelectionStatuses";
import KitStatusPage from "./pages/admin/KitStatus/KitStatus";
import AdminKitsPage from "./pages/admin/Kits/Kits";
import KitsByOrganization from "./pages/admin/KitsByOrganization/KitsByOrganization";
import KitsReceived from "./pages/admin/KitsReceived/KitsReceived";
import LCMSUploadFormPage from "./pages/admin/LcmsUploadForm/LcmsUploadForm";
import LCMSUploadsPage from "./pages/admin/LcmsUploads/LcmsUploads";
import Leads from "./pages/admin/Leads/Leads";
import MagicTable from "./pages/admin/MagicTable/MagicTable";
import ReviewWorkflow from "./pages/admin/ManualReview/ReviewWorkflow";
import OrderFulfillment from "./pages/admin/OrderFulfillment/OrderFulfillment";
import OrderPlacements from "./pages/admin/OrderPlacements/OrderPlacements";
import OrderShipments from "./pages/admin/OrderShipments/OrderShipments";
import UpcomingOrdersPage from "pages/admin/UpcomingOrders/UpcomingOrders";
import PcrUploadFormPage from "./pages/admin/PcrUploadForm/PcrUploadForm";
import PcrUploadsPage from "./pages/admin/PcrUploads/PcrUploads";
import ProgramEnrollments from "./pages/admin/ProgramEnrollments/ProgramEnrollments";
import Programs from "./pages/admin/Programs/Programs";
import DataReview from "./pages/admin/Reports/Reports";
import ReworksRequestForm from "./pages/admin/ReworksRequestForm/ReworksRequestForm";
import ReworksRequestedPage from "./pages/admin/ReworksRequested/ReworksRequested";
import RunbooksPage from "./pages/admin/Runbooks/RunbooksPage";
import SamplingLocation from "./pages/admin/SamplingLocation/SamplingLocation";
import SamplingLocations from "./pages/admin/SamplingLocations/SamplingLocations";
import TriageSheet from "./pages/admin/TriageSheet/TriageSheet";
import TubesReceivedToday from "./pages/admin/TubesReceivedToday/TubesReceivedToday";
import Users from "./pages/admin/Users/Users";
import Kit from "./pages/customer/Kit";
import Kits from "./pages/customer/Kits/Kits";
import Order from "./pages/customer/Order/Order";
import OrderForm from "./pages/customer/OrderForm/OrderForm";
import Orders from "./pages/customer/Orders/Orders";
import PilotSample from "./pages/customer/PilotSample/PilotSample";
import Sites from "./pages/customer/Sites/Sites";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import VarseqUploadFormPage from "./pages/admin/VarseqUploadForm/VarseqUploadForm";
import VarseqUploadsPage from "./pages/admin/VarSeqUploads/VarSeqUploads";
import VendorEventsPage from "./pages/admin/VendorEvents/VendorEvents";
import FunctionListView from "./pages/admin/Functions/views/list";
import FunctionRunView from "./pages/admin/Functions/views/run";
import GTMKitsReceived from "./pages/admin/GTMDashboards/KitsReceived";
import GTMResultsReceived from "./pages/admin/GTMDashboards/ResultsReceived";
import GTMOrderShipments from "./pages/admin/GTMDashboards/OrderShipments";
import GTMInvoiceChecks from "./pages/admin/GTMDashboards/InvoiceCheck";

ReactGA.initialize("UA-124209075-2", {
  testMode: process.env.NODE_ENV === "test",
});

export default function Routes(props) {
  const location = useLocation();

  return (
    <>
      <Switch location={location}>
        <PublicRoute
          exact
          path="/"
          component={Auth}
          restricted
          header={false}
          footer={false}
        />
        <PublicRoute
          path="/account"
          component={Auth}
          header={false}
          footer={false}
        />
        <PrivateRoute exact path="/kits" component={Kits} />
        <PrivateRoute
          exact
          path="/tubes-received-today"
          component={TubesReceivedToday}
        />
        <PrivateRoute
          exact
          path="/admin/tubes-received"
          component={TubesReceivedToday}
        />
        <PrivateRoute exact path="/kit/:id" component={Kit} />
        <PrivateRoute exact path="/sampling-locations" component={Sites} />
        <PrivateRoute exact path="/order" component={OrderForm} />
        <PrivateRoute exact path="/orders" component={Orders} />
        <PrivateRoute exact path="/order/:id" component={Order} />
        <PrivateRoute exact path="/leads" component={Leads} />
        <PrivateRoute exact path="/organizations" component={Accounts} />
        <PrivateRoute
          exact
          path="/organizations/:id"
          component={AccountDetails}
        />
        <PrivateRoute
          exact
          path="/admin/order-fulfillment"
          component={OrderFulfillment}
        />
        <PrivateRoute
          exact
          path="/admin/sampling-locations"
          component={SamplingLocations}
        />
        <PrivateRoute
          exact
          path="/admin/sampling-locations/:id"
          component={SamplingLocation}
        />
        <PrivateRoute exact path="/admin/kits" component={AdminKitsPage} />
        <PrivateRoute
          exact
          path="/admin/kits/selection-statuses"
          component={KitSelectionStatuses}
        />
        <PrivateRoute exact path="/users" component={Users} />
        <PrivateRoute exact path="/user/:id" component={UserForm} />
        <PrivateRoute
          exact
          path="/admin/rework-request"
          component={ReworksRequestForm}
        />
        <PrivateRoute
          exact
          path="/admin/reworks-requested"
          component={ReworksRequestedPage}
        />
        <PrivateRoute
          exact
          path="/admin/kit-receipt"
          component={KitReceiptPage}
        />
        <PrivateRoute
          exact
          path="/admin/kits-received"
          component={KitsReceived}
        />
        <PrivateRoute exact path="/admin/kit-issues" component={KitIssues} />
        <PrivateRoute
          exact
          path="/admin/kits-by-organization"
          component={KitsByOrganization}
        />
        <PrivateRoute
          exact
          path="/admin/triage-sheet"
          component={TriageSheet}
        />
        <PrivateRoute
          exact
          path="/admin/kits-operational-dashboard"
          component={KitOperationalDashboard}
        />
        <PrivateRoute
          exact
          path="/admin/order-placements"
          component={OrderPlacements}
        />
        <PrivateRoute
          exact
          path="/admin/order-shipments"
          component={OrderShipments}
        />
        <PrivateRoute
          exact
          path="/admin/upcoming-orders"
          component={UpcomingOrdersPage}
        />
        <PrivateRoute exact path="/admin/programs" component={Programs} />
        <PrivateRoute
          exact
          path="/admin/program-enrollments"
          component={ProgramEnrollments}
        />
        <Redirect from="/admin/qpcr-uploads" to="/admin/pcr-uploads" />
        <Redirect from="/admin/qpcr-upload-form" to="/admin/pcr-upload-form" />
        <PrivateRoute
          exact
          path="/admin/pcr-uploads"
          component={PcrUploadsPage}
        />
        <PrivateRoute
          exact
          path="/admin/pcr-upload-form"
          component={PcrUploadFormPage}
        />
        <PrivateRoute
          exact
          path="/admin/lcms-uploads"
          component={LCMSUploadsPage}
        />
        <PrivateRoute
          exact
          path="/admin/lcms-upload-form"
          component={LCMSUploadFormPage}
        />
        <PrivateRoute
          exact
          path="/admin/varseq-upload-form"
          component={VarseqUploadFormPage}
        />
        <PrivateRoute
          exact
          path="/admin/varseq-uploads"
          component={VarseqUploadsPage}
        />
        <PrivateRoute
          exact
          path="/admin/create-protocol-version"
          component={CreateProtocolPage}
        />
        <PrivateRoute
          exact
          path="/admin/kit-lookup"
          component={KitLookupPage}
        />
        <PrivateRoute
          exact
          path="/admin/kit-status-report"
          component={KitStatusPage}
        />
        <PrivateRoute
          exact
          path="/admin/manual-review"
          component={ReviewWorkflow}
        />
        <PrivateRoute exact path="/magic-table/:model" component={MagicTable} />
        <PrivateRoute exact path="/magic-table" component={MagicTable} />
        <PrivateRoute
          exact
          path="/runbooks/category/:categoryId"
          component={RunbooksPage}
        />
        <PrivateRoute exact path="/runbooks/:id" component={RunbooksPage} />

        <PrivateRoute
          exact
          path="/admin/functions/:name"
          component={FunctionRunView}
        />
        <PrivateRoute
          exact
          path="/admin/functions"
          component={FunctionListView}
        />

        <PrivateRoute
          exact
          path="/admin/vendor-events"
          component={VendorEventsPage}
        />

        {/* GTM Dashboards */}
        <PrivateRoute
          exact
          path="/admin/gtm-kits-received"
          component={GTMKitsReceived}
        />
        <PrivateRoute
          exact
          path="/admin/gtm-results-received"
          component={GTMResultsReceived}
        />
        <PrivateRoute
          exact
          path="/admin/gtm-order-shipments"
          component={GTMOrderShipments}
        />
        <PrivateRoute
          exact
          path="/admin/gtm-invoice-checks"
          component={GTMInvoiceChecks}
        />

        <PublicRoute exact path="/sample" component={PublicSample} />
        <PublicRoute exact path="/kit-pilot-sample" component={PilotSample} />
        <PrivateRoute exact path="/admin/data-review" component={DataReview} />
        <PrivateRoute exact path="/admin/invoicing" component={Invoicing} />
        <PublicRoute
          exact
          path="/sampling-location-metadata"
          component={SamplingLocationPublic}
        />
        {process.env.REACT_APP_DEMO_ROUTES === "true" && (
          <PublicRoute path="/demo" component={Demo} />
        )}

        {/* Signup forms */}
        <Route path="/sign-up" component={NetworkSignUp} />

        <Route path="/network-opt-in" component={NetworkCustomerOptIn} />

        <Route path="/cdc-sign-up" component={CDCSignUp} />

        <Route path="/nida-sign-up" component={NIDASignUp} />

        <Route path="/cchcs-sign-up" component={CCHCSSignUp} />

        {/* 404 Page */}
        <PublicRoute path="*" component={NotFound} />
      </Switch>
    </>
  );
}
